import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { mainSiteUrl } from "@/mocks/categories";

const languages = [
  { code: "en", label: "English" },
  { code: "fr", label: "Français" },
  { code: "da", label: "Dansk" },
  { code: "de", label: "Deutsch" },
];

export default function Footer() {
  const { t, i18n } = useTranslation();

  const resourceLinks = [
    { key: "footer.about", href: "/" },
    { key: "footer.editorial", href: "/" },
    { key: "footer.safety", href: "/" },
    { key: "footer.sitemap", href: "/" },
  ];

  const legalLinks = [
    { key: "footer.disclaimerLink", href: "/" },
    { key: "footer.privacy", href: "/" },
    { key: "footer.terms", href: "/" },
    { key: "footer.contact", href: "/" },
  ];

  return (
    <footer className="bg-secondary-100 border-t border-background-200">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-table-line" />
              </span>
              <span className="font-heading font-semibold text-lg text-foreground-950 whitespace-nowrap">
                AllChinaBuy Spreadsheet
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              {t("footer.tagline")}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">
              {t("footer.resourcesTitle")}
            </h4>
            <ul className="space-y-2">
              {resourceLinks.map((link) => (
                <li key={link.key}>
                  <Link
                    to={link.href}
                    className="text-sm text-foreground-600 hover:text-primary-700 cursor-pointer"
                  >
                    {t(link.key)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">
              {t("footer.legalTitle")}
            </h4>
            <ul className="space-y-2">
              {legalLinks.map((link) => (
                <li key={link.key}>
                  <Link
                    to={link.href}
                    className="text-sm text-foreground-600 hover:text-primary-700 cursor-pointer"
                  >
                    {t(link.key)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">
              {t("footer.languagesTitle")}
            </h4>
            <ul className="space-y-2">
              {languages.map((l) => (
                <li key={l.code}>
                  <button
                    type="button"
                    onClick={() => i18n.changeLanguage(l.code)}
                    className="text-sm text-foreground-600 hover:text-primary-700 cursor-pointer"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200">
          <p className="text-xs text-foreground-500 leading-relaxed max-w-3xl">
            {t("footer.disclaimer")}
          </p>
        </div>

        <div className="mt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} AllChinaBuy Spreadsheet.{" "}
            {t("footer.rights")}
          </p>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-700 hover:text-primary-800 whitespace-nowrap cursor-pointer"
          >
            {t("footer.mainSite")}
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-up-line" />
            </span>
          </a>
        </div>
      </div>
    </footer>
  );
}